import styled from "@emotion/styled";
import { Button } from "@mui/material";

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    background-color: #f5f5f5;
    position: relative;
`;

export const Header = styled.div`
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    background-color: #ab0c2f;
    width: 100%;
    padding: 12px 24px;
    box-shadow: 0 0 5px #ccc;
`;

export const Heading = styled.h2`
    color: #fff;
    font-family: Outfit;
    font-size: 26px;
    margin: 0;
    margin-top: 12px;
    line-height: 1.1;
`;

export const SubHeading = styled.h3`
    color: #fff;
    font-family: Outfit;
    font-size: 19px;
    font-weight: 400;
    margin: 0;
    margin-top: 8px;
    margin-bottom: 6px;
`;

export const Features = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    padding: 30px 16px;
    gap: 20px;
`;

export const FeatureCardWrapper = styled.div`
    background-color: #fff;
    width: 87%;
    padding: 14px 18px;
    display: flex;
    box-shadow: 0 0 12px #dedede;
    border-radius: 16px;
    transition: 0.2s ease-in-out;
    cursor: pointer;
    position: relative;
    user-select: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-tap-highlight-color: transparent;

    ${({ dontHover }) =>
        dontHover
            ? `&:hover {
        box-shadow: 0 0 12px #949494;
        scale: 1.02;
    }`
            : ""}

    &:active {
        scale: 1;
    }
    & svg {
        color: #aaaaaa;
    }

    &:hover svg {
        color: black;
        right: 0;
    }
`;
export const FeatureCardImage = styled.img`
    height: 60px;
    width: 60px;
`;
export const FeatureCardBody = styled.div`
    display: flex;
    flex-direction: column;
    margin-left: 18px;
`;

export const FeatureCardHeading = styled.h3`
    font-family: Outfit;
    font-size: 16px;
    font-weight: 600;
    margin: 0;
`;

export const FeatureCardP = styled.p`
    font-family: Outfit;
    font-size: 13px;
    font-weight: 400;
    margin: 0;
    margin-top: 4px;
    color: #000000b7;
`;

export const FeatureCardNextButton = styled.div`
    position: absolute;
    color: #ddd;
    right: 6px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    top: 2px;
    align-items: center;
    justify-content: center;
    transition: 0.2s ease-in-out;
    cursor: pointer;
`;

export const PoweredBy = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 30px;
    font-family: Outfit;
    font-size: 14px;
    font-weight: 500;
    color: #00000077;
`;

export const CITLink = styled.a`
    color: #00000077;
    margin-left: 4px;
    text-decoration: none;
    transition: 0.2s ease-in-out;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-family: Outfit;

    &:hover {
        text-decoration: underline;
    }
`;

export const BackButton = styled(Button)`
    position: absolute;
    border-radius: 1000px;
    top: 12px;
    left: 12px;
    background-color: #fff;
    color: #ab0c2f;
    box-shadow: 0 0 12px #dedede;
    transition: 0.2s ease-in-out;
    text-transform: none;
    box-shadow: 0 0 4px #d1d1d1;
    padding: 2px 4px;

    &:hover {
        box-shadow: 0 0 12px #d6d6d6;
        background-color: #fff;
        scale: 1.02;
    }
    &:active {
        scale: 1;
    }
`;

export const MeetInput = styled.input`
    width: 100%;
    font-family: Outfit;
    box-sizing: border-box;
    padding: 6px 12px;
    background-color: #ececec;
    font-size: 14px;
    outline: none;
    border: none;
    border-radius: 6px;
`;
